// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://htvdordrajveyklejsvs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh0dmRvcmRyYWp2ZXlrbGVqc3ZzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0MTY1MjgsImV4cCI6MjA2OTk5MjUyOH0.4lWZG_fhrC2_ifIc-gOKZEsXagkbGaGYGOib7UPwYCk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Check if running in native app context
const isNative = Capacitor.isNativePlatform();

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    // Prevent OAuth redirects in native apps - handle auth in-app only
    flowType: isNative ? 'pkce' : 'pkce',
    detectSessionInUrl: !isNative,
  }
});